export default {"src":"/_next/static/media/american-express.74f82218.svg","height":512,"width":512};